module.exports = __webpack_public_path__ + "img/erp-logos_0030_jiwa.511434a0.jpg";